import { Actions, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { SubmitRequested } from './form-subsmission.actions';

export function setupSubmissionResponse<P>(
  actions: Actions,
  params: {
    listenTo: string;
    failure: () => any;
    success: () => any;
    apiCall: (action: P) => Observable<any>;
  },
) {
  return actions.pipe(
    ofType<SubmitRequested<P>>(params.listenTo),
    switchMap(action => {
      return params.apiCall(action.payload).pipe(
        map(() => {
          return params.success();
        }),
        catchError(response => {
          return of(params.failure());
        }),
      );
    }),
  );
}
